var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentGptActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5547 6.28906V0H5.79688C4.43991 0 3.33594 1.10398 3.33594 2.46094V25.5391C3.33594 26.896 4.43991 28 5.79688 28H22.2031C23.5601 28 24.6641 26.896 24.6641 25.5391V7.10938H18.375C17.922 7.10938 17.5547 6.74209 17.5547 6.28906ZM21.3828 14.7656C21.3828 16.4093 20.5897 17.9423 19.1495 19.0824C17.7658 20.1779 15.937 20.7812 14 20.7812C13.6075 20.7812 13.2153 20.756 12.829 20.7061L10.2598 23.2753C10.1029 23.4323 9.89302 23.5156 9.67958 23.5156C9.57387 23.5156 9.46728 23.4952 9.36584 23.4532C9.05931 23.3262 8.85943 23.027 8.85943 22.6953V19.0892C7.42886 17.9605 6.61724 16.4058 6.61724 14.7656C6.61724 13.122 7.41037 11.5889 8.85052 10.4488C10.2342 9.35331 12.063 8.75 14 8.75C15.937 8.75 17.7658 9.35331 19.1495 10.4488C20.5897 11.5889 21.3828 13.122 21.3828 14.7656ZM24.1835 5.46868L19.1953 0.480469V5.46868H24.1835ZM8.25781 14.7656C8.25781 12.3533 10.8338 10.3906 14 10.3906C17.1662 10.3906 19.7422 12.3533 19.7422 14.7656C19.7422 17.178 17.1662 19.1406 14 19.1406C13.5575 19.1406 13.116 19.1016 12.6878 19.0247C12.4234 18.9773 12.1527 19.0622 11.9628 19.2521L10.5 20.7149V18.676C10.5 18.407 10.3681 18.155 10.1469 18.0018C8.94638 17.1698 8.25781 15.9902 8.25781 14.7656ZM12.3594 17.2266H15.6406C16.0937 17.2266 16.4609 16.8593 16.4609 16.4062C16.4609 15.9532 16.0937 15.5859 15.6406 15.5859H12.3594C11.9063 15.5859 11.5391 15.9532 11.5391 16.4062C11.5391 16.8593 11.9063 17.2266 12.3594 17.2266ZM11.5391 13.125C11.5391 13.578 11.9063 13.9453 12.3594 13.9453H15.6406C16.0937 13.9453 16.4609 13.578 16.4609 13.125C16.4609 12.672 16.0937 12.3047 15.6406 12.3047H12.3594C11.9063 12.3047 11.5391 12.672 11.5391 13.125Z",
    fill: "url(#paint0_linear_760_2592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_760_2592",
    x1: 21,
    y1: 20.5625,
    x2: 15.1654,
    y2: -1.99854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGptActive);
export default __webpack_public_path__ + "static/media/document_gpt_active.98d180bc46d4b4dfe7ae4ba4e5962df0.svg";
export { ForwardRef as ReactComponent };